The listing status of the job ad on SEEK.

Currently, two status are defined:

- `Active` indicates the job ad is listed on SEEK.
- `Suspended` indicates the job ad has been suspended.
- `Expired` indicates the job ad has been closed.

When a job ad is suspended, SEEK emits a `PositionProfileUpdated` event.
When a job ad expired, SEEK emits a `PositionProfileClosed` event.
Partners can query this field after receiving the event to determine the current status.
